import axios from 'axios';

// import router from './router';

let config = {
    baseURL: 'https://www.dev-rental.evenware.com/'
};


const httpClient = axios.create(config);

export default httpClient;

// window.axios = axios
// axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://localhost/vrs_vuejs_new/basic/';

// axios.interceptors.request.use(function(config){



//     return config;
// })